import { render, staticRenderFns } from "./DepositAmount.vue?vue&type=template&id=2fe3fd4c"
import script from "./DepositAmount.vue?vue&type=script&lang=js"
export * from "./DepositAmount.vue?vue&type=script&lang=js"
import style0 from "./DepositAmount.vue?vue&type=style&index=0&id=2fe3fd4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports